import {CookieService} from './cookies';

$(document).ready(() => { 
    $('[data-social-media-tracker-follower]').on('click', (item) => {
        if (CookieService.IsGdprAccepted()){
            trackSocialMediaFollowers();
        }
    });
});

function trackSocialMediaFollowers() {
    CookieService.SetSocialMediaFollowersCookie('true');
}